<template>
    <b-form-group class="mb-0 w-100">
        <div v-if="label">
            <label>{{ label }}</label>
        </div>
        <div class="d-flex">
            <b-input
                v-model="value_"
                class="mr-2"
                type="text"
                placeholder="Enter a quantity..."
                :disabled="disabled"
            />
            <b-input
                v-model="unit_"
                placeholder="Enter a unit..."
                :disabled="disabled"
            />
        </div>
        <slot name="validation" />
    </b-form-group>
</template>

<script>
import { formatFloat } from '../utils/helpers';

export default {

    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: Object,
            default: () => ({
                value: null,
                unit: null,
            }),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            quantity__: this.value,
        };
    },

    computed: {
        value_: {
            get() {
                return this.quantity__.value;
            },
            set(val) {
                this.quantity__.value = val;
                this.$emit('input', this.quantity__);
            },
        },
        unit_: {
            get() {
                return this.quantity__.unit;
            },
            set(val) {
                this.quantity__.unit = val;
                this.$emit('input', this.quantity__);
            },
        },
    },

};
</script>
